module.exports = __webpack_public_path__ + "img/divider.a49ed9ba.svg";